import type { RouteRecordRaw } from "vue-router";
const onError = (error: any) => {
  console.error("Failed to load async component: ", error);
  throw new Error(error);
};
const Workbench: RouteRecordRaw = {
  path: "/workbench",
  name: "工作台管理",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  meta: {
    key: "/workbench"
  },
  children: [
    {
      name: "工作台面板",
      path: "index",
      component: () => import("@/views/Workbench/index.vue").catch(onError),
      meta: {
        key: "/workbench/index",
        keepAlive: true
      }
    }
  ]
};
export default Workbench;
